import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { Organizacao, Unidade } from '../models/organograma.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrganogramaService extends BaseService {
    controllerRoute = 'Organograma';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getOrganizacoesFilhas(id: string): Promise<IBaseModel<Organizacao[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Organizacao[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/OrganizacoesFilhas/${id}`));
    }

    public async getOrganizacao(id: string): Promise<IBaseModel<Organizacao>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Organizacao>>(`${this.apiBaseUrl}/${this.controllerRoute}/Organizacao/${id}`));
    }

    public async getUnidadesOrganizacao(id: string): Promise<IBaseModel<Unidade[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Unidade[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/UnidadesOrganizacao/${id}`));
    }

    public async getUnidade(id: string): Promise<IBaseModel<Unidade>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Unidade>>(`${this.apiBaseUrl}/${this.controllerRoute}/Unidade/${id}`));
    }
}
